import { AppServices } from '@singularsystems/neo-core';
import AllocationManagerService from './Services/AllocationManagerService';

// Symbols to expose outside of this module
export const AllocationManagerSharedTypes = {    
    Services: {        
        AllocationManagerService: new AppServices.ServiceIdentifier<AllocationManagerService>("AllocationManager.Services.AllocationManagerService"),
    }
}